export const REPORT_TYPE_ID_MAP = {
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3,
  BIANNUALLY: 4,
  ANNUALLY: 5,
}

export const REPORT_REPORT_TYPE_NAME_MAP = {
  1: 'daily',
  2: 'weekly',
  3: 'monthly',
  4: 'biannually',
  5: 'annually',
}